import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ToasterProvider } from './components/Toaster';
import { routeTree } from './routeTree.gen';
import './styles.css';

const router = createRouter({ routeTree });
const qc = new QueryClient({ defaultOptions: { queries: { staleTime: 10_000 } } });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <ToasterProvider>
        <RouterProvider router={router} />
      </ToasterProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
